import { ApplicationConfig } from "@angular/core";
import { provideRouter, Routes } from "@angular/router";
import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { provideHttpClient } from "@angular/common/http";

import { VersionComponent } from "./pages/version/version.component";
import { LoginComponent } from "./pages/login/login.component";
import { ForgotPasswordComponent } from "./pages/forgot-password/forgot-password.component";
import { AuthenticatedComponent } from "./pages/authenticated/authenticated.component";
import { PickerComponent } from "./pages/authenticated/picker/picker.component";
import { DemoComponent } from "./pages/demo/demo.component";
import { ResetPasswordComponent } from "./pages/reset-password/reset-password.component";
import { LogoutComponent } from "./pages/logout/logout.component";
import { ContinueComponent } from "./pages/continue/continue.component";
import { UpdatePasswordComponent } from "./pages/authenticated/update-password/update-password.component";
import { MfaComponent } from "./pages/mfa/mfa.component";
import { MfaPickerComponent } from "./pages/mfa/mfa-picker/mfa-picker.component";
import { MfaEmailComponent } from "./pages/mfa/mfa-email/mfa-email.component";
import { MfaAuthenticatorComponent } from "./pages/mfa/mfa-authenticator/mfa-authenticator.component";
import { MfaBackupComponent } from "./pages/mfa/mfa-backup/mfa-backup.component";
import { MfaSetupComponent } from "./pages/mfa-setup/mfa-setup.component";
import { AddMfaComponent } from "./pages/mfa-setup/add-mfa/add-mfa.component";
import { MfaStatusComponent } from "./pages/mfa-status/mfa-status.component";
import { OnboardingPasswordComponent } from "./pages/onboarding-password/onboarding-password.component";
import { InviteComponent } from "./pages/invite/invite.component";
import { InviteSetPasswordComponent } from "./pages/invite-set-password/invite-set-password.component";
import { InviteExpiredComponent } from "./pages/invite-expired/invite-expired.component";
import { UpdateEmailComponent } from "./pages/authenticated/update-email/update-email.component";
import { RegisterComponent } from "./pages/register/register.component";
import { PasswordResetLoginComponent } from "./pages/password-reset-login/password-reset-login.component";
import { RegisterEmailSentComponent } from "./pages/register-email-sent/register-email-sent.component";
import { RegisterCompleteComponent } from "./pages/register-complete/register-complete.component";
import { EmailConfirmedComponent } from "./pages/email-confirmed/email-confirmed.component";
import { EmailOtpComponent } from "./pages/email-otp/email-otp.component";
import { MagicLinkComponent } from "./pages/magic-link/magic-link.component";
import { NotFoundComponent } from "./pages/not-found/not-found.component";
import { ConfigurationComponent } from "./pages/configuration/configuration.component";

const routes: Routes = [
  { path: "", component: LoginComponent },
  { path: "register", component: RegisterComponent },
  { path: "register-email-sent", component: RegisterEmailSentComponent },
  { path: "register-complete", component: RegisterCompleteComponent },
  { path: "email-confirmed", component: EmailConfirmedComponent },
  { path: "continue", component: ContinueComponent },
  { path: "email-otp", component: EmailOtpComponent },
  { path: "magic-link", component: MagicLinkComponent },
  { path: "forgot-password", component: ForgotPasswordComponent },
  { path: "demo", component: DemoComponent },
  { path: "callback", component: DemoComponent },
  { path: "change-password", component: ResetPasswordComponent },
  { path: "password-reset-login", component: PasswordResetLoginComponent },
  { path: "set-password", component: UpdatePasswordComponent },
  {
    path: "mfa", component: MfaComponent, children: [
      { path: "", component: MfaPickerComponent },
      { path: "email", component: MfaEmailComponent },
      { path: "authenticator", component: MfaAuthenticatorComponent },
      { path: "backup", component: MfaBackupComponent },
    ]
  },
  { path: 'onboarding-password', component: OnboardingPasswordComponent },
  { path: "invite", component: InviteComponent },
  // Before "invite/:token", otherwise these paths would be read as a token.
  { path: "invite/set-password", component: InviteSetPasswordComponent },
  { path: "invite/expired", component: InviteExpiredComponent },
  { path: "invite/:token", component: InviteComponent },
  // Legacy OneWelcome invite links carry no CDC token, so they end on /invite/expired.
  { path: "personal/invite/sign-up-unp", component: InviteComponent },
  {
    path: "",
    component: AuthenticatedComponent,
    children: [
      { path: "mfa-status", component: MfaStatusComponent },
      { path: "mfa-setup", component: MfaSetupComponent },
      { path: "mfa-setup/add", component: AddMfaComponent },
      { path: "picker", component: PickerComponent },
      { path: "update-password", component: UpdatePasswordComponent },
      { path: "update-email", component: UpdateEmailComponent },
    ],
  },
  { path: "logout", component: LogoutComponent },
  { path: "version", component: VersionComponent },
  { path: "configuration", component: ConfigurationComponent },
  { path: "**", component: NotFoundComponent }, // Redirect invalid routes to default
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: "/assets/i18n/",
        suffix: ".json",
      }),
      fallbackLang: "en",
      lang: "en",
    }),
  ],
};
